import { Typography } from '@mui/material'
import Modal from 'src/components/Modal'
import * as S from './WithoutUnreceivedProductsModal.styles'

interface WithoutUnreceivedProductsModalProps {
  show: boolean
  onClose: () => void
}

const WithoutUnreceivedProductsModal = ({ show, onClose }: WithoutUnreceivedProductsModalProps) => (
  <Modal
    show={show}
    testId='without-unreceived-products-modal-test-id'
    centered
    title='Associação de produtos'
    closedButton
    closeButtonAction={onClose}
    body={(
      <S.Container>
        <Typography>Não há produtos para serem associados.</Typography>
        <Typography>
          Se houver nota fiscal para ser bipada, utilize o botão <strong>Gerenciar notas fiscais</strong>, senão clique no botão <strong>Confirmar produto errado</strong>.
        </Typography>
        <Typography sx={{ fontStyle: 'italic' }}>Obs.: caso nenhuma das opções atenda e já tenha resolvido todas as pendências, clique em <strong>Prosseguir</strong>.</Typography>
        <S.CustomButton
          title='Ok'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          data-testid='ok-button-test-id'
          onClick={onClose}
        />
      </S.Container>
    )}
  />
)

export default WithoutUnreceivedProductsModal
